import { render, staticRenderFns } from "./StatementRequirements.vue?vue&type=template&id=7432f66c&"
import script from "./StatementRequirements.vue?vue&type=script&lang=js&"
export * from "./StatementRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports